import { onMounted, ref, computed } from "vue"
import { useStore } from "vuex"

export default {
    name: "ProfileEditedOverlay",
    props: {
        profileSettingsPageUrl: {
            type: String,
            required: true
        }
    },
    setup(props) {
        const store = useStore()
        const profileSettingsPageUrl = computed(() => props.profileSettingsPageUrl ?? store.state.main.page_overlay_content_data.profileSettingsPageUrl)
            
        const descriptionWrapper = ref(null)

        const decodeHtml = (htmlRaw) => {
            const txt = document.createElement('textarea')
            txt.innerHTML = htmlRaw
            return txt.value
        }

        onMounted(() => {
            var descriptionRaw = getLabel('description')
            var descriptionHtml = decodeHtml(descriptionRaw)
            descriptionWrapper.value.innerHTML = descriptionHtml
        })

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'ProfileEditedOverlay',
                labelKey
            })

        const hasLabel = (labelKey) => 
            store.getters['labels/existLabel']({
                labelCollection: 'ProfileEditedOverlay',
                labelKey
            })

        const closeOverlay = () => {
            store.dispatch('main/closePageOverlay')
        }

        return {
            getLabel,
            hasLabel,
            closeOverlay,
            profileSettingsPageUrl,
            descriptionWrapper
        }
    }
}